module.exports = __webpack_public_path__ + "img/eye.ac3baa2b.svg";